import { toolRouteForHost } from './hostTool'

/**
 * True when the current request is a public, DB-independent compute-tool
 * context — either a `/tools/*` path or one of the dedicated tool subdomains
 * (e.g. `volume.beetlesense.ai`, resolved by {@link toolRouteForHost}).
 *
 * These contexts are client-side calculators with **no Supabase dependency**, so
 * they must stay available even when the backend is unreachable. The App's
 * `supabaseDown` maintenance gate uses this to avoid taking the free tools dark
 * during an outage — they're the zero-friction prospecting surface (CLAUDE.md:
 * "free tools = reach"). This regressed once when a refactor simplified the gate
 * and dropped the exemption; keeping the predicate here, unit-tested, guards it.
 */
export function isPublicToolContext(pathname: string, hostname: string | undefined | null): boolean {
  if (pathname.startsWith('/tools')) return true
  return toolRouteForHost(hostname) != null
}
